/* Kurotsuki shop / collection page: category chips, filters, sorting and cards.
   Products, prices and availability come from Shopify (window.KT_SHOP); photos and
   model data (kind, category) come from kurotsuki-products.js. */
(function(){
  if(!window.KT_SHOP || !document.getElementById("shop-grid")) return;

  const local = (h) => getProductById(KT_HANDLE_MAP[h]) || {};
  const ALL = window.KT_SHOP.map(o => {
    const l = local(o.handle);
    return Object.assign({}, l, o, { name: o.title, soon: o.status !== "available", soldOut: o.status === "soldout" });
  });

  // default order: on sale first, then coming soon / sold out, in the original catalogue order
  const handleOrder = Object.keys(KT_HANDLE_MAP);
  const rank = { available: 0, soon: 1, soldout: 2 };
  ALL.sort((a, b) => (rank[a.status] - rank[b.status]) || (handleOrder.indexOf(a.handle) - handleOrder.indexOf(b.handle)));

  const MODEL_LABEL = { Gyuto: "Gyuto koksmes", Santoku: "Santoku", Bunka: "Bunka allroundmes", Sujihiki: "Sujihiki vleesmes", Broodmes: "Broodmes", Sets: "Complete set" };
  const MODEL_ORDER = ["Gyuto", "Santoku", "Bunka", "Sujihiki", "Broodmes", "Sets"];
  const cats = SHOP_CATEGORIES.filter(c => ALL.some(p => p.kind === c.id));
  const state = { cat: "all", models: new Set(), price: "all", avail: new Set() };

  const imgSrc = (p) => (p.image || "").trim();
  const isJpg = (p) => !!imgSrc(p) && !/\.png(\?|$)/.test(imgSrc(p));

  function cardHTML(p){
    const real = isJpg(p);
    if(p.soon){
      const label = p.soldOut ? "Uitverkocht" : "Binnenkort";
      return `
      <article class="pc pc-soon">
        <a class="pc-media${real ? " is-real" : ""}" href="${p.url}" aria-label="${p.name}, ${p.soldOut ? "uitverkocht" : "binnenkort beschikbaar"}">
          <span class="pc-badge">${label}</span>
          <img src="${imgSrc(p)}" alt="${p.name}" loading="lazy" />
        </a>
        <div class="pc-body">
          <h3 class="pc-title"><a href="${p.url}">${p.name}</a></h3>
          <p class="pc-short">${p.short || ""}</p>
          <a class="pc-soon-note" href="${p.url}">Bekijk het mes</a>
        </div>
      </article>`;
    }
    return `
    <article class="pc" data-product-card="${p.handle}">
      <a class="pc-media${real ? " is-real" : ""}" href="${p.url}" aria-label="${p.name}">
        <img src="${imgSrc(p)}" alt="${p.name}" loading="lazy" />
      </a>
      <div class="pc-body">
        <h3 class="pc-title"><a href="${p.url}">${p.name}</a></h3>
        ${p.short ? `<p class="pc-short">${p.short}</p>` : ""}
        <div class="pc-price">${p.compareFormatted ? `<span class="price-old">${p.compareFormatted}</span>` : ""}<span class="price">${p.priceFormatted}</span>${p.saveFormatted ? `<span class="pc-save">Je bespaart ${p.saveFormatted}</span>` : ""}</div>
        <button class="btn btn-primary btn-block pc-add" data-add-to-cart="${p.variantId}">In winkelwagen <span aria-hidden="true">→</span></button>
      </div>
    </article>`;
  }

  function renderChips(){
    document.getElementById("shop-chips").innerHTML = [{ id: "all", label: "Alle messen" }].concat(cats).map(c => {
      const n = c.id === "all" ? ALL.length : ALL.filter(p => p.kind === c.id).length;
      return `<button type="button" class="chip" data-cat="${c.id}" aria-pressed="${state.cat === c.id}">${c.label}<span class="chip-n">${n}</span></button>`;
    }).join("");
  }

  function renderModels(){
    const inCat = ALL.filter(p => state.cat === "all" || p.kind === state.cat);
    const list = MODEL_ORDER.filter(m => inCat.some(p => p.category === m));
    document.getElementById("filter-models").innerHTML = list.map(m => `
      <label class="filter-option"><input type="checkbox" name="model" value="${m}" ${state.models.has(m) ? "checked" : ""} /> <span>${MODEL_LABEL[m] || m}</span><em class="filter-n">${inCat.filter(p => p.category === m).length}</em></label>`).join("");
    document.getElementById("models-group").hidden = list.length < 2;
  }

  function matches(p){
    if(state.cat !== "all" && p.kind !== state.cat) return false;
    if(state.models.size && !state.models.has(p.category)) return false;
    if(state.avail.size && !state.avail.has(p.status === "available" ? "now" : (p.status === "soldout" ? "sold" : "soon"))) return false;
    if(state.price !== "all"){
      if(p.soon) return false;
      const [lo, hi] = state.price.split("-").map(Number);
      if(p.price < lo || p.price >= hi) return false;
    }
    return true;
  }

  const activeCount = () => state.models.size + state.avail.size + (state.price !== "all" ? 1 : 0);

  function renderShop(){
    const list = ALL.filter(matches);
    const sort = document.getElementById("sort-select").value;
    const order = (a, b) => (a.soon - b.soon);
    if(sort === "price-asc") list.sort((a, b) => order(a, b) || a.price - b.price);
    else if(sort === "price-desc") list.sort((a, b) => order(a, b) || b.price - a.price);
    else if(sort === "name") list.sort((a, b) => a.name.localeCompare(b.name, "nl"));

    document.getElementById("shop-grid").innerHTML = list.map(cardHTML).join("");
    document.getElementById("shop-empty").hidden = list.length > 0;
    document.getElementById("shop-count").textContent = list.length + (list.length === 1 ? " mes" : " messen");
    const n = activeCount();
    document.getElementById("filter-count").textContent = n ? "(" + n + ")" : "";
    document.getElementById("filters-reset").hidden = n === 0 && state.cat === "all";
    document.querySelectorAll("#shop-chips .chip").forEach(c => c.setAttribute("aria-pressed", c.dataset.cat === state.cat));
  }

  function setCategory(id, push){
    state.cat = id;
    const inCat = new Set(ALL.filter(p => id === "all" || p.kind === id).map(p => p.category));
    [...state.models].forEach(m => { if(!inCat.has(m)) state.models.delete(m); });
    renderModels();
    if(push !== false) history.replaceState(null, "", id === "all" ? location.pathname + location.search : location.pathname + location.search + "#" + id);
    renderShop();
  }

  function resetFilters(){
    state.models.clear(); state.avail.clear(); state.price = "all";
    document.querySelectorAll('#filters input[name=price]').forEach(i => { i.checked = i.value === "all"; });
    document.querySelectorAll('#filters input[name=avail]').forEach(i => { i.checked = false; });
    setCategory("all");
  }

  document.getElementById("shop-chips").addEventListener("click", (e) => { const b = e.target.closest(".chip"); if(b) setCategory(b.dataset.cat); });
  // chips carousel: arrows + blurred ends when the row overflows
  (function(){
    const wrap = document.getElementById("chips-wrap"), row = document.getElementById("shop-chips");
    if(!wrap || !row) return;
    const bg = getComputedStyle(document.body).backgroundColor;
    if(bg && bg !== "rgba(0, 0, 0, 0)") wrap.style.setProperty("--kt-fade", bg);
    const update = () => {
      const max = row.scrollWidth - row.clientWidth;
      wrap.classList.toggle("can-prev", row.scrollLeft > 4);
      wrap.classList.toggle("can-next", row.scrollLeft < max - 4);
      wrap.classList.toggle("has-scroll", max > 4);
    };
    const step = dir => row.scrollBy({ left: dir * Math.max(160, row.clientWidth * 0.6), behavior: "smooth" });
    wrap.querySelector(".kt-pairs-prev").addEventListener("click", () => step(-1));
    wrap.querySelector(".kt-pairs-next").addEventListener("click", () => step(1));
    row.addEventListener("scroll", update, { passive: true });
    window.addEventListener("resize", update);
    new MutationObserver(update).observe(row, { childList: true });
    update();
  })();
  document.getElementById("filters").addEventListener("change", (e) => {
    const t = e.target;
    if(t.name === "model") t.checked ? state.models.add(t.value) : state.models.delete(t.value);
    if(t.name === "avail") t.checked ? state.avail.add(t.value) : state.avail.delete(t.value);
    if(t.name === "price") state.price = t.value;
    renderShop();
  });
  document.getElementById("filters-reset").addEventListener("click", resetFilters);
  document.getElementById("empty-reset").addEventListener("click", resetFilters);
  document.getElementById("sort-select").addEventListener("change", renderShop);
  document.getElementById("filter-toggle").addEventListener("click", (e) => {
    const open = document.getElementById("filters").classList.toggle("open");
    e.currentTarget.setAttribute("aria-expanded", open);
  });
  window.addEventListener("hashchange", () => { const id = location.hash.slice(1); if(id === "" || cats.some(c => c.id === id)) setCategory(id || "all", false); });

  renderChips();
  const startCat = location.hash.slice(1);
  state.cat = cats.some(c => c.id === startCat) ? startCat : "all";
  renderModels();
  renderShop();
})();
